import React, { Component } from "react";
import Home from "./components/pages/home/Home";
import About from "./components/pages/about/About";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import $ from "jquery";
import SEO from "./components/pages/seo/SEO";
import JaelsCreations from "./components/pages/projects/JaelsCreations";
import TheGoodFight from "./components/pages/projects/TheGoodFight";
import ProductManufacturing from "./components/pages/projects/ProductManufacturing";
import Caregiver from "./components/pages/projects/Caregiver";
import Contact from "./components/pages/contact/Contact";

export default class App extends Component {
  // Closing the mobile navmenu
  closeMenu() {
    $(".NavMenu .overlay-container").addClass("fast-close");
    $(".NavMenu .overlay-container").removeClass("open");
    $(".NavMenu .page-cover").addClass("fast-close");
    $(".NavMenu .page-cover").removeClass("open");
  }

  // Handling page transitions
  onEnter() {
    var transitionEl = $('<div class="transition-cover"></div>');

    // Add the Transition Element
    $("body").append(transitionEl);

    // Hide the Entering Page
    $(".fade-enter").addClass("hidden");

    setTimeout(
      function() {
        $(".fade-enter").removeClass("hidden"); // Reveal the entering page
        this.closeMenu();
        window.scrollTo(0, 0);
      }.bind(this),
      425
    );

    transitionEl.on(
      "webkitAnimationEnd oanimationend msAnimationEnd animationend",
      function() {
        transitionEl.remove(); // Remove the transition element
      }
    );
  }
  render() {
    return (
      <BrowserRouter>
        <Route
          render={({ location }) => (
            <TransitionGroup>
              <CSSTransition
                key={location.pathname}
                timeout={1000}
                classNames="fade"
                onEnter={this.onEnter.bind(this)}
              >
                <Switch location={location}>
                  <Route exact={true} path="/" component={Home} />
                  <Route exact={true} path="/about" component={About} />
                  <Route exact={true} path="/seo" component={SEO} />
                  <Route exact={true} path="/contact" component={Contact} />
                  <Route
                    exact={true}
                    path="/jaels-creations"
                    component={JaelsCreations}
                  />
                  <Route
                    exact={true}
                    path="/the-good-fight"
                    component={TheGoodFight}
                  />
                  <Route
                    exact={true}
                    path="/product-manufacturing"
                    component={ProductManufacturing}
                  />
                  <Route exact={true} path="/caregiver" component={Caregiver} />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          )}
        />
      </BrowserRouter>
    );
  }
}
